module.exports = __webpack_public_path__ + "public/1.0.1_896977/img/submitFinish.3d4488e3.jpeg";